var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.ventas, function(venta) {
                  return _c("tr", { key: venta.numero_documento }, [
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn-info btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.verVenta(venta)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(venta.numero_documento) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(venta.fecha) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(venta.nombre_supervisor) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(venta.descripcion_dia_cobro) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.moneyFormat(venta.venta_total)) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn-warning btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.verComentarios(venta)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-comments" }),
                          _c("span", [_vm._v("Comentarios")])
                        ]
                      )
                    ])
                  ])
                }),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.ventas.length == 0,
                        expression: "ventas.length == 0"
                      }
                    ]
                  },
                  [_vm._m(2)]
                )
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            attrs: { type: "button" },
            on: { click: _vm.cerrar }
          },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cerrar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "comentariosVenta",
            height: "auto",
            width: "60%",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: ""
          }
        },
        [
          _c("comentarios-venta", {
            attrs: { ventaId: _vm.currentVentaId },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("comentariosVenta")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Ventas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("# Cartilla")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha")]),
        _vm._v(" "),
        _c("th", [_vm._v("Supervisor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Día de cobro")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "5" } }, [
      _c("strong", [_vm._v("No se ha encontrado ventas.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5076002", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5076002","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/VentasDashboard.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f5076002","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/VentasDashboard.vue
// module chunks = 0